import { useCallback } from 'react';

import { IStationFilter } from 'store/features/stations/types/stationFilter';

import dataSources from 'dataSources';

export const useGetFilteredStationCodes = () => {
  const getFilteredStationCodes = useCallback(async (filter: IStationFilter) => {
    try {
      return await dataSources.stations.getStationCodes(filter);
    } catch (e) {
      return [];
    }
  }, []);

  return getFilteredStationCodes;
};
